import React, { useContext, useEffect, useState } from "react";
import { RotatingLines } from 'react-loader-spinner';
import { cloneDeep } from 'lodash';
import { EmpdContext, EmpdProvider } from "../../../../../Context";
import DashboardNavigationBar from "./DashboardNavigationBar";
import WelcomeBanner from "./WelcomeBanner";
import ContentWrapper from "../../../../../Components/ContentWrapper";
import Paper from '@mui/material/Paper';
import NCTTable from '../../../../../Components/NCTTable';
import NCTTableColumn from '../../../../../Interfaces/NCTTableColumn';
import HeaderCell from '../../../../../Interfaces/HeaderCell';
import VirtualizedSelect from '../../../../../Components/VirtualizedSelect';
import DashboardCard from './DashboardCard'
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser"
import MsalLoadingComponent from "../../../../../Components/Msal/MsalLoadlingComponent"
import MsalErrorComponent from "../../../../../Components/Msal/MsalErrorComponent"
import NotAuthorized from "../../../../../Components/NotAuthorized";
import { isProvider } from "../../../../../utils";

interface Props {
    classes?: any,
}

const renderResources = (classes: any) => {

    return (
        <div className={classes.dashboardWrapper}>
            <ContentWrapper>
                <div className={classes.dashboardContent}>
					Additional resources and educational materials will be available here soon.
                </div>
            </ContentWrapper>
        </div>
    )
}

const render = (classes: any, isLoading: boolean, patientResult: any) => {

    return (
        <div>
            <DashboardNavigationBar />
            <WelcomeBanner />
                <DashboardCard
                    title={'Resources / Educational'}
                    className={classes.dashboardCard}
                >
                    {isLoading && (
						<div className='center'>
	                        <RotatingLines
    	                      strokeColor="#152E54"
        	                  strokeWidth="3"
            	              animationDuration="1.00"
                	          width="48"
                    	      visible={true}
                        	/>
						</div>
                    )}
                    {!isLoading && (
                        <>
                            {renderResources(classes)}
                        </>
                    )}
                </DashboardCard>
        </div>
    );
}

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

// This component displays patient data from context
const Resources = ({ classes }: Props) => {

    const { isLoading, patientResult, activeMrn, setActiveMrn, fetchPatientData, fetchClinicalTrials, clinicalTrials, countClinicalTrials, conditionSet, fetchNamespace, user, isPatientLoading } = useMyContext()
	const { instance } = useMsal()

    useEffect(() => {
		fetchNamespace()
        if( activeMrn === null ) {
           setActiveMrn(localStorage.getItem('userObjectId') as string)
        } else if( Object.keys(patientResult).length === 0 ) {
            fetchPatientData(activeMrn)
        } 
    }, [])
    
    useEffect(() => {
		if( activeMrn !== null && conditionSet != undefined ) {
            fetchPatientData(activeMrn)
        } 
    }, [activeMrn, conditionSet])
    
    return (
		<MsalAuthenticationTemplate 
			interactionType={InteractionType.Redirect}
			errorComponent={NotAuthorized}
	        loadingComponent={MsalLoadingComponent}
		>
			{(!isLoading && isPatientLoading && isProvider(user)) ? 
				<NotAuthorized />
			:
	        	<EmpdProvider>
    	        	{render(classes, isLoading, patientResult)}
		        </EmpdProvider>
			}
		</MsalAuthenticationTemplate>
    );
};

export default Resources;
